import { useState, useEffect } from "react";
import { getBranches } from "../services/branches";

let cachedBranches = null; // global in-memory cache

export const useBranches = ({ reload = false, params = {} } = {}) => {
  const [branches, setBranches] = useState(cachedBranches || []);
  const [loading, setLoading] = useState(false);

  const fetchBranches = async () => {
    setLoading(true);
    try {
      const [err, data] = await getBranches(params);
      if (!err) {
        cachedBranches = data || [];
        setBranches(cachedBranches);
      }
    } catch (e) {
      console.error("Error fetching branches:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!cachedBranches || reload) {
      fetchBranches();
    } else {
      setBranches(cachedBranches);
    }
  }, [reload, JSON.stringify(params)]); // refetch if reload or params change

  return { branches, loading, refresh: fetchBranches };
};
